import { Pipe, PipeTransform } from '@angular/core'
import striptags from 'striptags'

export function stripTags(html: string, allowed_tags: string | string[] = [], tag_replacement: string = ''): string {
  return striptags(html, allowed_tags, tag_replacement).replace(/&nbsp;/g, '')
}

export const htmlToPlainText = stripTags

@Pipe({
  name: 'stripHtml',
  standalone: false,
})
export class StripHtmlPipe implements PipeTransform {
  transform(html: string, allowed_tags: string | string[] = [], tag_replacement: string = ''): string {
    return stripTags(html, allowed_tags, tag_replacement)
  }
}
